var map = {
	"./Aquarius.svg": "6fc5",
	"./Aries.svg": "e306",
	"./Cancer.svg": "c4fc",
	"./Capricorn.svg": "d12b",
	"./Gemini.svg": "278a",
	"./Leo.svg": "db3c",
	"./Libra.svg": "2068",
	"./Pisces.svg": "b136",
	"./Sagittarius.svg": "574f",
	"./Scorpio.svg": "52e1",
	"./Taurus.svg": "164a",
	"./Virgo.svg": "70ce"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "33b9";